export const CURRENT_OPERATOR = 'CURRENT_OPERATOR';
